import { createContext, useState, ReactNode, useEffect } from "react";
import { DEFAULT_THEME } from "@/constants/constants";

// Context for theme state
const ThemeStateContext = createContext<
  "light" | "dark" | "system" | undefined
>(undefined);
// Context for theme updater
const ThemeUpdateContext = createContext<
  ((theme: "light" | "dark" | "system") => void) | undefined
>(undefined);

// Helper to retrieve the initial theme from localStorage or system preference
const getInitialTheme = (): "light" | "dark" | "system" => {
  return DEFAULT_THEME
  // if (typeof window !== "undefined") {
  //   const savedTheme = localStorage.getItem("theme");
  //   if (
  //     savedTheme === "dark" ||
  //     savedTheme === "light" ||
  //     savedTheme === "system"
  //   ) {
  //     return savedTheme;
  //   }
  //   const prefersDark = window.matchMedia(
  //     "(prefers-color-scheme: dark)"
  //   ).matches;
  //   return prefersDark ? "dark" : DEFAULT_THEME;
  // }
  // return DEFAULT_THEME;
};

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<"light" | "dark" | "system">(
    getInitialTheme
  );

  // Apply or remove the 'dark' class based on the current theme
  useEffect(() => {
    const root = window.document.documentElement;
    if (
      theme === "dark" ||
      (theme === "system" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [theme]);

  // setTheme function to directly set a specific theme
  const updateTheme = (newTheme: "light" | "dark" | "system") => {
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme); // Persist the new theme
  };

  return (
    <ThemeStateContext.Provider value={theme}>
      <ThemeUpdateContext.Provider value={updateTheme}>
        {children}
      </ThemeUpdateContext.Provider>
    </ThemeStateContext.Provider>
  );
};

export { ThemeStateContext, ThemeUpdateContext };
